import { onDomReady } from '../utils/dom';
import { scrollToTarget } from '../utils/scrolling';

function initDataTables() {
    const tables = document.querySelectorAll('.mod_eventlist table');
    const filter = document.getElementById('event-filter');

    if (!filter || tables.length === 0) {
        return;
    }

    import('simple-datatables').then(({ DataTable }) => {
        tables.forEach((table) => {
            const module = table.closest('.mod_eventlist');
            const search = document.querySelector('#event-filter [name=search]');
            const selects = document.querySelectorAll('#event-filter select');
            const firstRow = table.querySelector('tbody tr');
            const categoryColumn = firstRow ? Array.from(firstRow.cells).findIndex((cell) => cell.classList.contains('categories')) : -1;

            const dataTable = new DataTable(table, {
                perPage: 10,
                perPageSelect: false,
                searchable: false,
                sortable: false,
                // Keeps the column headers of the template, the stylesheet hides them visually
                header: true,
                nextPrev: false,
                // Pages differ in height (wrapped titles and locations), a fixed height would add an inner scrollbar
                fixedHeight: false,
                // No inline column widths: the stylesheet lays the rows out as a grid on small screens
                fixedColumns: false,
                labels: {
                    placeholder: 'Suchen...', // The search input placeholder
                    searchTitle: 'In Tabelle suchen', // The search input title
                    perPage: 'Einträge pro Seite', // per-page dropdown label
                    noRows: 'Keine Einträge gefunden.', // Message shown when there are no records to show
                    noResults: 'Es wurden keine Einträge zu deiner Suche gefunden.', // Message shown when there are no search results
                    info: '', // Pagination info
                },
            });

            const queries = () => {
                const query = [];

                for (const select of selects) {
                    const values = select.value.split('|');
                    query.push({ terms: values, columns: [categoryColumn >= 0 ? categoryColumn : 1] });
                }

                if (search.value) {
                    query.push({ terms: [search.value] });
                }

                return query;
            };

            // The next page starts at the top of the table, not where the pagination was
            dataTable.on('datatable.page', () => {
                scrollToTarget(dataTable.containerDOM);
            });

            dataTable.on('datatable.init', () => {
                if (module.classList.contains('no-filter')) {
                    return;
                }

                dataTable.multiSearch(queries());

                search.addEventListener('input', () => {
                    dataTable.multiSearch(queries());
                });

                for (const select of selects) {
                    select.addEventListener('change', () => {
                        dataTable.multiSearch(queries());
                    });
                }
            });
        });
    });
}

onDomReady(() => {
    initDataTables();
});
